import BaseTableBody from '@material-ui/core/TableBody'

const TableBody = BaseTableBody

export default TableBody
